// @flow
import React from 'react';
import styles from './styles.module.scss';

type Recap = {
  hands: number,
  correct: number,
  accuracy: number,
  bestStreak: number,
};
type Props = {
  recap: ?Recap,
  onDismiss: () => void,
};

const SessionRecap = ({ recap, onDismiss }: Props) => {
  if (!recap) return null;
  const accuracy = Number(recap.accuracy.toFixed(1));

  return (
    <section
      className={styles.sessionRecap}
      aria-label="Training session recap"
      data-trainer-session-recap
      data-session-recap
    >
      <div className={styles.recapHeader}>
        <h3 className={styles.recapHeading}>
          <span className={styles.recapDot} aria-hidden="true" />
          Session complete
        </h3>
        <button
          className={styles.recapDismiss}
          type="button"
          onClick={onDismiss}
          aria-label="Dismiss session recap"
          title="Dismiss session recap"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="m7 7 10 10M17 7 7 17" />
          </svg>
        </button>
      </div>
      <dl className={styles.recapStats}>
        <div className={styles.recapStat} data-recap-stat="hands">
          <dt>Hands</dt>
          <dd>{recap.hands}</dd>
        </div>
        <div className={styles.recapStat} data-recap-stat="accuracy">
          <dt>Accuracy</dt>
          <dd>
            {accuracy}
            %
          </dd>
          <dd className={styles.recapDetail}>
            {recap.correct}
            {' '}
            of
            {' '}
            {recap.hands}
            {' '}
            correct
          </dd>
        </div>
        <div className={styles.recapStat} data-recap-stat="bestStreak">
          <dt>Best streak</dt>
          <dd>{recap.bestStreak}</dd>
        </div>
      </dl>
    </section>
  );
};

export default SessionRecap;
